import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type TransitionCourtCaseMutationVariables = Types.Exact<{
  input: Types.TransitionCourtCaseInput
}>

export type TransitionCourtCaseMutation = { __typename?: 'Mutation'; transitionCourtCase: boolean }

export const TransitionCourtCaseDocument = gql`
  mutation TransitionCourtCase($input: TransitionCourtCaseInput!) {
    transitionCourtCase(input: $input)
  }
`
export type TransitionCourtCaseMutationFn = ApolloReactCommon.MutationFunction<
  TransitionCourtCaseMutation,
  TransitionCourtCaseMutationVariables
>
export function useTransitionCourtCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    TransitionCourtCaseMutation,
    TransitionCourtCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    TransitionCourtCaseMutation,
    TransitionCourtCaseMutationVariables
  >(TransitionCourtCaseDocument, options)
}
export type TransitionCourtCaseMutationHookResult = ReturnType<
  typeof useTransitionCourtCaseMutation
>
export type TransitionCourtCaseMutationResult =
  ApolloReactCommon.MutationResult<TransitionCourtCaseMutation>
export type TransitionCourtCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<
  TransitionCourtCaseMutation,
  TransitionCourtCaseMutationVariables
>
